import {
  type DownloadEventArgs,
  makeDownloadEvent,
} from '@iconik-io/shared-lib/src/analytics/download_event';

import type { AppDispatch, GetState } from '../../store/types';
import { segmentTrackEvent } from '../analytics_tracking/thunks';
import { selectIsSharePage } from '../share/selectors';

export const trackDownloadEvent =
  (options: Omit<DownloadEventArgs, 'isShare'>) =>
  (dispatch: AppDispatch, getState: GetState) => {
    dispatch(
      segmentTrackEvent(
        makeDownloadEvent({
          ...options,
          isShare: selectIsSharePage(getState()),
        }),
      ),
    );
  };
